import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetPlatformInfo } from './PlatformInfo';
import { getStaleTimeInMinutes } from '@/shared/utils/staleTime.ts';

export function usePlatformInfo() {
    const { getPlatformInfo } = useGetPlatformInfo();

    return useSuspenseQuery({
        queryKey: ['platformInfo'],
        queryFn: getPlatformInfo,
        staleTime: getStaleTimeInMinutes(15),
    });
}

export function usePlatformCurrencyCode() {
    const { data } = usePlatformInfo();

    return data.platform.market.currencyCode;
}

export function usePlatformOrganizationId() {
    const { data } = usePlatformInfo();

    return data.platform.market.platformOrganizationId;
}
